module.exports = __webpack_public_path__ + "static/media/preslot_inbound_header.70e5b45a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/preslot_inbound_header.svg
// module id = 100
// module chunks = 0